export const iconFontAwesomeLogisticsRoadCircleExclamation = (
	<i className="fa-solid fa-road-circle-exclamation"></i>
);
